import { Button, Form, Input, Modal, message } from "antd";
import Checkbox from "antd/es/checkbox/Checkbox";
import { useForm } from "antd/es/form/Form";
import Policy from "app/components/Policy";
import Bg from "assets/images/bg-login.png";
import Logo from "assets/images/logo-blue.png";
import { STORAGE } from "constant";
import { PAGE_ROUTE, PUBLIC_ROUTE } from "constant/routes/page";
import { useHandleSubmitApi } from "hook";
import { ILoginInputModel } from "interfaces";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AuthServices } from "services";
import { StorageUtil } from "utils/storage";
import "./Login.style.scss";

type P_Props = {};

const LoginPresenter = (props: P_Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [form] = useForm();

  const [handleSubmitApi, loading] = useHandleSubmitApi(async (data: ILoginInputModel) => {
    const dataRes = await AuthServices.login(data);
    if (dataRes) {
      message.success(t("LOGIN_SUCCESSFULLY"));
      StorageUtil.setItem(STORAGE.LOCAL_ACCESS_TOKEN, dataRes.data.accessToken);
      StorageUtil.setItem(STORAGE.LOCAL_REFRESH_TOKEN, dataRes.data.refreshToken);
      return navigate(PAGE_ROUTE.ADM_INVENTORY);
    }
  });

  const handleSubmit = () => {
    form
      .validateFields()
      .then((res) => {
        !loading && handleSubmitApi(res);
      })
      .catch((e) => console.log(e));
  };

  return (
    <Modal
      open={true}
      width={1680}
      bodyStyle={{ height: "calc(100vh - 190px)" }}
      footer={null}
      closable={false}
      wrapClassName="login-modal"
    >
      <div className="login">
        <div className="login-form">
          <div className="login-form__inner">
            <img src={Logo} alt="" width={196} style={{ marginTop: 20 }} />
            <h1 style={{ alignSelf: "flex-start" }}>Đăng nhập</h1>
            <Form
              form={form}
              className="w_100 mt_2"
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  handleSubmit();
                }
              }}
            >
              <Form.Item name="email" noStyle>
                <Input size="large" className="mb_1" placeholder="Đăng nhập bằng email/ account đã cấp" />
              </Form.Item>
              <Form.Item name="password" noStyle>
                <Input.Password size="large" className="mb_1" placeholder="Mật khẩu" type="password" />
              </Form.Item>
              <div className="login-form__remember">
                <Checkbox>Nhớ mật khẩu</Checkbox>
                <div className="text-underline c-pointer" onClick={() => navigate(PUBLIC_ROUTE.FORGOT_PASSWORD)}>
                  Quên mật khẩu
                </div>
              </div>
              <Button size="large" className="btn btn-full mt_2" loading={loading} onClick={handleSubmit}>
                Đăng nhập
              </Button>
            </Form>
            <div className="login-form__footer">
              <Policy />
            </div>
          </div>
        </div>

        <div className="login-image">
          <img src={Bg} alt="" height={"100%"} width={"100%"} />
        </div>
      </div>
    </Modal>
  );
};

export default LoginPresenter;
